import type { ObjectDefinitionView, ObjectStatsView, SchemaImpact } from '@takeit4me/shared'
import type { Http } from '../http'

const enc = encodeURIComponent

export interface SchemaCheckBody { key: string; op: 'create' | 'update' | 'delete'; after?: unknown }

/** Console API methods: workstream B (objects and fields designer, layouts, indexes, analytics). */
export interface SchemaApi {
  /** Every object's full definition, with record counts, index states and open change sets (Settings). */
  objectDefinitions(): Promise<ObjectDefinitionView[]>
  objectDefinition(key: string): Promise<ObjectDefinitionView>
  /** What a proposed definition would do to the stored records, before it is drafted. */
  checkObject(body: SchemaCheckBody): Promise<SchemaImpact>
  /** Counts, weekly activity and breakdowns for one object (CRM). */
  objectStats(key: string): Promise<ObjectStatsView>
  /** Retry building field indexes now (admins). */
  syncObjectIndexes(): Promise<{ ok: true; work: number }>
}
export const schemaMethods = (http: Http): SchemaApi => ({
  objectDefinitions: () => http.get<ObjectDefinitionView[]>('/crm/schema/objects'),
  objectDefinition: (key) => http.get<ObjectDefinitionView>(`/crm/schema/objects/${enc(key)}`),
  checkObject: (body) => http.post<SchemaImpact>('/crm/schema/check', body),
  objectStats: (key) => http.get<ObjectStatsView>(`/crm/schema/objects/${enc(key)}/stats`),
  syncObjectIndexes: () => http.post<{ ok: true; work: number }>('/crm/schema/indexes/sync'),
})
